import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { ContractDefinitionApiPort } from './ports/contract-definition-api.port';
import { AdessoContractDefinitionApiAdapter } from './adapters/adesso-contract-definition-api.adapter';

/**
 * Provides ContractDefinitionApiPort backed by the adesso-connector-api adapter.
 */
export function provideContractDefinitionApi(): EnvironmentProviders {
  return makeEnvironmentProviders([
    { provide: ContractDefinitionApiPort, useClass: AdessoContractDefinitionApiAdapter }
  ]);
}
